import React, { Fragment, useContext } from 'react';
import moment from 'moment/moment';
import { MomentFormatTypes } from "../utils";
import getDateFormat from "./getDateFormat";
import LocalizationContext from "../LocalizationProvider/LocalizationContext";

var FormattedDate = function FormattedDate(_ref) {
  var _ref$format = _ref.format,
      format = _ref$format === void 0 ? MomentFormatTypes.Date : _ref$format,
      date = _ref.date,
      variant = _ref.variant;
  var Tag = variant || Fragment;
  var momentDate = moment(date);

  var _useContext = useContext(LocalizationContext),
      isEnglish = _useContext.isEnglish;

  return momentDate.isValid() ? React.createElement(Tag, null, momentDate.format(getDateFormat(format, isEnglish))) : React.createElement(Fragment, null, "Invalid date");
};

export default FormattedDate;